<script setup lang="ts">
import './assets/style.scss'
import { useModel } from './../model/model.ts'

const props = defineProps({
  scheduleId: {
    type: Number,
    required: true,
  },
})

const model = useModel()

/**
 * Функция обработчик кнопки открытия
 */
const clickHandler = () => {
  if (props.scheduleId) {
    model.openForm = true
    model.editId = props.scheduleId
  }
}
</script>

<template>
  <div @click="clickHandler">
    <slot />
  </div>
</template>
